import { BsRobot } from "react-icons/bs";
import styles from "../../../styles/Components/new-dashboard/bot-performance/NoBotMessage.module.css";
import { Link } from "react-router-dom";

function NoBotMessage() {
  return (
    <div className={styles.container}>
      <BsRobot size={50} color="rgb(108,117,125)" />
      <h6>Welcome to Bot Automation!</h6>
      <p>You haven't created any trading bots yet. Let's get started!</p>
      <Link className={styles.btn} to="/bot-automation">
        Create Your First Bot
      </Link>
      <span>
        Automate your trading strategies and let our AI-powered bots work for
        you 24/7.
      </span>
    </div>
  );
}

export default NoBotMessage;
